export default __webpack_public_path__ + "static/media/web-dev-icon.b7eab028.png";